/* global angular */
( function () {
	'use strict';

	function canvasGetter ( canvasHelper ) {
		function linkFn ( scope, elem ) {
			canvasHelper.clearData();
			var key = 'canvas-' + scope.graphId;

			canvasHelper[ key ]               = {};
			canvasHelper[ key ].setCanvasData = function ( graphTitle, subtitle ) {
				elem[ 0 ].querySelector( 'svg' ).setAttribute( 'id', 'img' + scope.graphId );

				var type    = ( scope.graphId === 'obs-level' ) && 'Observation' || 'Section';
				var dataObj = {
					'headerTitle' : type + ' Level Graph',
					'graphTitle'  : graphTitle,
					'subtitle'    : subtitle,
					'id'          : scope.graphId
				};

				canvasHelper.setData( dataObj, type );
			};
		}

		return {
			'restrict' : 'A',
			'link'     : linkFn
		};
	}

	canvasGetter.$inject = [ 'canvasHelper' ];

	angular
		.module( 'app.report' )
		.directive( 'canvasGetter', canvasGetter );
} )();
